import Table from "../../../component/table/Table";
// import tableData from "../../../utils/produzione/produzioniData.json";
import { useDispatch, useSelector } from "react-redux";
import { selectError, selectIsLoading } from "../../../features/produzioni/produzioniSlice";
import { useEffect } from "react";
import { fetchCompanies } from "../../../features/company/companyThunk";
import { fetchProduzioni } from "../../../features/produzioni/produzioniThunk";
import { selectSelectedCompany } from "../../../features/company/companySlice";
import { fetchProdotti } from "../../../features/Prodotti/prodottiThunk";

const Produzioni = () => {
    const columns = [
        { field: "nomeDellaProduzione", headerName: "Nome della produzione", width: 1042 },
        { field: "prodotto", headerName: "Prodotto", width: 263 },
        { field: "stato", headerName: "Stato", width: 190 },
        { field: "tracciabilita", headerName: "Tracciabilità", width: 184 },
        { field: "azioni", headerName: "Azioni", width: 60, sortable: false }
    ];
    const dispatch = useDispatch();
    const Produzioniata = useSelector((state) => state.produzioni?.produzioni);
    const selectedCompany = useSelector(selectSelectedCompany);
    const isLoading = useSelector(selectIsLoading);
    const error = useSelector(selectError);
 useEffect(() => {
        dispatch(fetchCompanies())
    },[])
    useEffect(() => {
              dispatch(fetchProdotti()); // Dispatch the fetchProdotti action to get the data
        
        dispatch(fetchProduzioni());
    }, [dispatch, selectedCompany]);
    return (
        <>
            <div className="pageTemplate">
                <Table data={Produzioniata} columns={columns} navData={"produzioni"} deleteFunctions={"deleteProduzioneData"}/>
            </div> 
        </>
    );
};

export default Produzioni;